import { render, staticRenderFns } from "./AwardWorks.vue?vue&type=template&id=302b7fb4&scoped=true&"
import script from "./AwardWorks.vue?vue&type=script&lang=js&"
export * from "./AwardWorks.vue?vue&type=script&lang=js&"
import style0 from "./AwardWorks.vue?vue&type=style&index=0&id=302b7fb4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "302b7fb4",
  null
  
)

export default component.exports